import sound from '../audio/error.mp3'

const playSoundError = () => {
    console.log('Loading Sound Error');
    const audio = new Audio(sound);
    audio.volume = 1;
    audio.play().catch(e => console.error('Erro ao tocar som:', e));
}

export { playSoundError }
 